module.exports = __webpack_public_path__ + "img/Cricle.4a5b7663.svg";